import React, { use, useEffect, useState } from "react";
import classes from "./ConnectWithUs.module.css";
import { Col, Form, Input, notification, Row } from "antd";
import TextArea from "antd/es/input/TextArea";
import { LoadingOutlined } from "@ant-design/icons";
import ContactService from "../../../services/contact";
import ConnectWithUsForm from "../../../components/page-components/connect-with-us-form/ConnectWithUsForm";

const ConnectWithUs = ({ branchData }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  console.log("branch dta", branchData);
  const [embedUrl, setEmbedUrl] = useState("");
  console.log("embedUrl", embedUrl);

  const code = `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3929.0335418913664!2d76.5676005!3d10.0140881!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b07e73c4162167b%3A0xd44c46fe44266096!2sSabine%20Hospital%20-%20Muvattupuzha!5e0!3m2!1sen!2sin!4v1738053970098!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`;

  useEffect(() => {
    const fetchMapDetails = async () => {
      try {
        // Extract place ID or Lat/Long from the short link
        // This part assumes that you can extract the necessary information from the Google Maps link.
        const placeId = branchData?.mapUrl?.split("goo.gl/")[1]; // Extract the part of the URL

        // Construct the embed URL with the API key
        const embedBaseUrl = `https://www.google.com/maps/embed/v1/place?key=AIzaSyBucHHSLvAcbRq3CWGkRzzdYo7Da8hIzCQ&q=place_id:${placeId}`;

        setEmbedUrl(embedBaseUrl);
      } catch (error) {
        console.error("Error resolving Google Maps link:", error);
      }
      //   try {
      //     // Resolve the shortened URL to get the full URL
      //     const response = await fetch(branchData?.mapUrl, {
      //       method: "HEAD", // Use HEAD to follow redirects and get the resolved URL
      //       redirect: "follow",
      //     });

      //     // Get the final resolved URL
      //     const resolvedUrl = response.url;

      //     // Extract the place ID or coordinates from the resolved URL
      //     const placeIdMatch = resolvedUrl.match(/\/place\/([^/]+)/);
      //     const coordinatesMatch = resolvedUrl.match(/@([-.\d]+),([-.\d]+)/);

      //     if (placeIdMatch) {
      //       // If place ID is found
      //       const placeId = placeIdMatch[1];
      //       setEmbedUrl(
      //         `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.8354345093746!2d${placeId}`
      //       );
      //     } else if (coordinatesMatch) {
      //       // If coordinates are found
      //       const latitude = coordinatesMatch[1];
      //       const longitude = coordinatesMatch[2];
      //       setEmbedUrl(
      //         `https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1!2d${longitude}!3d${latitude}!3m2!1i1024!2i768!4f13.1!2m2`
      //       );
      //     } else {
      //       console.error("Failed to extract place or coordinates from the URL");
      //     }
      //   } catch (error) {
      //     console.error("Error resolving map URL:", error);
      //   }
    };
    if (branchData) {
      fetchMapDetails();
    }
  }, [branchData]);

  const onFinish = () => {
    setLoading(true);
    form
      .validateFields()
      .then(async (values) => {
        console.log("values", values);
        if (values.phoneNumber && !values.phoneNumber.startsWith("+")) {
          values.phoneNumber = `+${values.phoneNumber}`;
        }
        const response = await ContactService.createContact(values);
        console.log("response", response);
        if (response.success) {
          notification.success({
            message: response.message,
          });
          form.resetFields();
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log("error", err);
      });
  };

  return (
    <div className={classes.container}>
      <div className={classes.title} data-aos="fade-down" data-aos-delay="200">
        <h1 className="bg-primary-200 primary-300">Contact Us</h1>
        <h3 className={classes.titleHeading}>
          Connect <span>with Us</span>
        </h3>
        {/* <div className={classes.underLine}></div> */}
      </div>
      <div className={classes.detailsSection} >
        <div className={classes.partSection} data-aos="fade-right" data-aos-delay="200">
          <ConnectWithUsForm
            form={form}
            loading={loading}
            onFinish={onFinish}
            showPar = {false}
          />
        </div>
        <div className={classes.partSection} data-aos="fade-down" data-aos-delay="200">
          <div className={classes.mapContainer}>
            <div
              dangerouslySetInnerHTML={{
                __html: branchData?.mapUrl
                  ?.replace(/width="[^"]*"/, "")
                  ?.replace(/height="[^"]*"/, ""),
              }}
              style={{ width: "100%", height: "100%" }}
            ></div>
            {/* <iframe
              src={branchData?.mapUrl.replace(
                "maps.app.goo.gl",
                "www.google.com/maps"
              )}
              //   src={embedUrl}
              //   src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15556.584372394263!2d77.65020600000001!3d12.898326!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae14a11a335985%3A0x670a91483bc6968!2sVivifi%20Life%20sciences%20Pvt%20Ltd!5e0!3m2!1sen!2sus!4v1704694046416!5m2!1sen!2sus"
              width="100%"
              height="100%"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Contact Us"
            ></iframe> */}
          </div>
          <div className={classes.infoSection}>
            <div className={classes.parameterHead}>
              <img
                src="/img/icons/contact-phone.svg"
                alt="contact"
                className={classes.phoneIcon}
              />
              <h3>Contact Numbers:</h3>
            </div>
            {/* <a
              href={`tel:${branchData?.contactNumbers?.generalEnquiries}`}
              style={{ textDecoration: "none" }}
            >
              <h4 className={classes.info}>
                General Inquiries:{" "}
                {branchData?.contactNumbers?.generalEnquiries}
              </h4>
            </a>
            <a
              href={`tel:${branchData?.contactNumbers?.emergencyContact}`}
              style={{ textDecoration: "none" }}
            >
              <h4 className={classes.info}>
                Emergency Services (24/7):{" "}
                {branchData?.contactNumbers?.emergencyContact}
              </h4>
            </a> */}
            <a
              href={`tel:${branchData?.contactNumbers?.appointments}`}
              style={{ textDecoration: "none" }}
            >
              <h4 className={classes.info}>
                Appointments: {branchData?.contactNumbers?.appointments}
              </h4>
            </a>
            {/* <a
              href={`tel:${branchData?.contactNumbers?.whatsappNumber}`}
              style={{ textDecoration: "none" }}
            >
              <h4 className={classes.info}>
                Whatsapp Number: {branchData?.contactNumbers?.whatsappNumber}
              </h4>
            </a> */}
          </div>
          <div className={classes.infoSection}>
            <div className={classes.parameterHead}>
              <img
                src="/img/icons/contact-email.svg"
                alt="email"
                className={classes.emailIcon}
              />
              <h3>Email Address:</h3>
            </div>
            <a
              href={`mailto:${branchData?.email}`}
              style={{ textDecoration: "none" }}
            >
              <h4 className={classes.info}>{branchData?.email}</h4>
            </a>
          </div>
          <div className={classes.infoSection}>
            <div className={classes.parameterHead}>
              <img
                src="/img/icons/contact-map.svg"
                alt="contact"
                className={classes.mapIcon}
              />
              <h3>Address:</h3>
            </div>
            <h4 className={classes.info}>{branchData?.address}</h4>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConnectWithUs;
